// extracted by mini-css-extract-plugin
export default {"b2bPageRoot":"b2bGammaTheme_b2bPageRoot__3oGOZ"};